import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-slate py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold text-sand mb-4 font-space">
            AgentTailor.ai
            </h3>
            <p className="text-sand/80 mb-4 max-w-md">
              Custom AI agents and automations that deliver outcomes, not hype. Private-ready solutions for SMBs.
            </p>
            <p className="text-sand/60 text-sm">
              Let us tailor your AI solution.
            </p>
          </div>
          
          <div>
            <h4 className="text-sand font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-sand/80 text-sm">
              <li><Link to="/services" className="hover:text-sky transition-colors">Workflow Automation</Link></li>
              <li><Link to="/mailing" className="hover:text-sky transition-colors">Direct Mail</Link></li>
              <li><Link to="/services" className="hover:text-sky transition-colors">Private AI Assistants</Link></li>
              <li><Link to="/services" className="hover:text-sky transition-colors">Data Collection</Link></li>
              <li><Link to="/services" className="hover:text-sky transition-colors">System Integration</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-sand font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-sand/80 text-sm">
              <li><Link to="/about" className="hover:text-sky transition-colors">About</Link></li>
              <li><Link to="/case-studies" className="hover:text-sky transition-colors">Case Studies</Link></li>
              <li><Link to="/contact" className="hover:text-sky transition-colors">Contact</Link></li>
              <li><button className="hover:text-sky transition-colors text-left">Privacy Policy</button></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-sand/20 mt-8 pt-8 text-center">
          <p className="text-sand/60 text-sm">
            © 2025 AgentTailor.ai. All rights reserved. • DPA available on request.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
